<!-- It is created by Kalpesh 25-5-2021 -->
<div class="topDiv" style="margin-top: 3%;
overflow-x: hidden;">
    <div class="agGridOuterDiv">
      <div>

        <div class="row topRowMargins headerStyle">

            <div class="col-lg-12">

               Create Report Template

            </div>

        </div>


    </div>


      <div style="margin-top: 25px;">
            <form novalidate [formGroup]='validations_form'>
              <div class="row">
                <div class="col-lg-1">
                </div>
                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@TMclassifiedserviceType">select Dataset</mat-label>
                    <input matInput type="text" (click)="userMultiDropdown()" [(ngModel)]="reportCreationData.datasetname" formControlName="selectdataSet" readonly>
                  </mat-form-field>
                </div>


                <div class="col-lg-2" style="text-align: center;">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@TMSTAFFMASTERfirstname">Report Template Name</mat-label>
                    <input matInput type="text" placeholder="Report Template Name" formControlName="reporttemplatename" [(ngModel)]="reportCreationData.reporttemplatename"  maxlength="100" required>
                    <mat-error *ngFor="let validation of validation_messages.reporttemplatename">
                      <span
                          *ngIf="validations_form.get('reporttemplatename').hasError(validation.type) && (validations_form.get('reporttemplatename').dirty || validations_form.get('reporttemplatename').touched)">
                          {{ validation.message }}
                      </span>
                  </mat-error>
                  </mat-form-field>
                </div>


                <div class="col-lg-2" style="text-align: center;">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@TMSTAFFMASTERfirstname">Details</mat-label>
                    <input matInput type="text" placeholder="details" formControlName="details" [(ngModel)]="reportCreationData.details"  maxlength="100" required>
                    <mat-error *ngFor="let validation of validation_messages.details">
                      <span
                          *ngIf="validations_form.get('details').hasError(validation.type) && (validations_form.get('details').dirty || validations_form.get('details').touched)">
                          {{ validation.message }}
                      </span>
                  </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCFormulaexpression">Type</mat-label>
                    <mat-select [(ngModel)]="reportCreationData.type" formControlName="type">
                      <mat-option>None</mat-option>
                      <mat-option *ngFor="let type of arrangeTypeBy"
                        [(value)]="type.value">
                        {{type.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCFormulaexpression">Access Type</mat-label>
                    <mat-select [(ngModel)]="reportCreationData.accesstype" formControlName="accesstype">
                      <mat-option>None</mat-option>
                      <mat-option *ngFor="let accesstype of arrangeDatasetBy"
                        [(value)]="accesstype.value">
                        {{accesstype.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-1">
                </div>
              </div>
              <div class="row">
                <div class="col-lg-1">
                </div>

                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCFormulaexpression">Vault Document Type</mat-label>
                    <mat-select [(ngModel)]="reportCreationData.vaultDocumentType" formControlName="vaultDocumentType">
                      <mat-option>None</mat-option>
                      <mat-option *ngFor="let type of arrangeTypeBy"
                        [(value)]="type.value">
                        {{type.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCFormulaexpression">Vault Document Subtype</mat-label>
                    <mat-select [(ngModel)]="reportCreationData.documentsubtype" formControlName="documentsubtype">
                      <mat-option>None</mat-option>
                      <mat-option *ngFor="let accesstype of arrangeDatasetBy"
                        [(value)]="accesstype.value">
                        {{accesstype.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCFormulaexpression">Vault Clasification</mat-label>
                    <mat-select [(ngModel)]="reportCreationData.vaultClasification" formControlName="vaultClasification">
                      <mat-option>None</mat-option>
                      <mat-option *ngFor="let accesstype of arrangeDatasetBy"
                        [(value)]="accesstype.value">
                        {{accesstype.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-2" style="text-align: center;">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@TMSTAFFMASTERfirstname">Vault Template</mat-label>
                    <input matInput type="text" placeholder="vault Template" formControlName="vaultTemplate" [(ngModel)]="reportCreationData.vaultTemplate"  maxlength="100" required>
                    <mat-error *ngFor="let validation of validation_messages.vaultTemplate">
                      <span
                          *ngIf="validations_form.get('vaultTemplate').hasError(validation.type) && (validations_form.get('vaultTemplate').dirty || validations_form.get('vaultTemplate').touched)">
                          {{ validation.message }}
                      </span>
                  </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-2" style="text-align: center;">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@TMSTAFFMASTERfirstname">Vault Binder Template</mat-label>
                    <input matInput type="text" placeholder="vaultbinderTemplate" formControlName="vaultbinderTemplate" [(ngModel)]="reportCreationData.vaultbinderTemplate"  maxlength="100" required>
                    <mat-error *ngFor="let validation of validation_messages.vaultbinderTemplate">
                      <span
                          *ngIf="validations_form.get('vaultbinderTemplate').hasError(validation.type) && (validations_form.get('vaultbinderTemplate').dirty || validations_form.get('vaultbinderTemplate').touched)">
                          {{ validation.message }}
                      </span>
                  </mat-error>
                  </mat-form-field>
                </div>


                <div class="col-lg-1">
                </div>
              </div>
            </form>
          </div>
    </div><br>

    <div style="
    margin-left: 8%;
    margin-right: 8%;
    margin-bottom: 2em;
    border-bottom: 0.01px ridge coral;"></div>

      <div style="margin-left:2%;margin-right:2%">
          <div class="container" style="border-bottom: 0.01px ridge coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                        <div class="row topRowMargins">
                        
            <label style="font-weight: 500;
            font-size: larger;
            color: black;">Filters <em class="fas fa-filter" style="font-size:20px"></em></label>
            </div>
                </div>
                </div>
             
              <div class="container">
              <div  class="row" *ngIf="showFilter" style="margin-top: -30px;margin-bottom: 30px;">
              <div class="table-responsive">
                <table class="table" style="margin-top: -57px;"><caption></caption>
                  <thead>
                    <tr>
                      <th class="th-lg">Key</th>
                      <th class="th-lg">Condition</th>
                      <th class="th-lg">Value</th>
                      <th class="th-lg">Remove</th>
                    </tr>
                  </thead>
                  <tbody style="border:none;">
                    <tr *ngFor="let whereData of where; let k= index;">
                      <td class="conditionsalign">{{whereData.whereKey}}</td>
                      <td class="conditionsalign" style="padding-left: 115px;">{{whereData.whereCondition}}</td>
                      <td class="conditionsalign" style="padding-left: 120px;">{{whereData.whereValue}}</td>
                      <td class="conditionsalign" style="text-align: end;
                      padding-right: 33px;"><button  class ="CloseButtonStyle"><span> <em (click)="deleteWhere(k)" class="fas fa-minus" style="color: white;"></em></span></button></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          
                  <form novalidate [formGroup]="formValidWhere">
                    <div>
                      <div class="row topRowMargins" style="margin-top: -25px;">
                        <div class="col-lg-4">
                          <mat-form-field appearance="outline">
                            <mat-label i18n="@@RCFields">Fields</mat-label>
                            <mat-select [(ngModel)]="whereData.fieldsWhere" (selectionChange)="whereKey($event.value)" formControlName="fieldsWhere">
                              <mat-option>None</mat-option>
                              <mat-option *ngFor="let field of selectedFieldsDataToPush" [(value)]="field.attributeNameAndFields">
                                {{field.attributeNameAndFields}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-lg-3">
                          <mat-form-field appearance="outline">
                            <mat-label i18n="@@RCConditionalOperators">Condition</mat-label>
                            <mat-select [(ngModel)]="whereData.conditionalOperatorWhere"
                              formControlName="conditionalOperatorWhere">
                              <mat-option>None</mat-option>
                              <mat-option *ngFor="let conditionalOperator of conditionalOperatorDataWhere"
                                [(value)]="conditionalOperator.value">
                                {{conditionalOperator.name}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-lg-4">
                        <div *ngIf="fieldChange">
                          <mat-form-field appearance="outline">
                            <mat-label i18n="@@RCEnterValue">Enter Value</mat-label>
                            <input matInput type="text" maxlength="50" formControlName="enterValueWhere"
                              [(ngModel)]="whereData.enterValueWhere">
                          </mat-form-field>
                        </div>
                        <div *ngIf="dateChange">
                          <mat-form-field appearance="outline">
                            <mat-label i18n="@@TMSTAFFMASTERLastname">Select Date</mat-label>
                            <input matInput [(ngModel)]="whereData.enterValueWhereDate" [matDatepicker]="whereDate"
                                readonly formControlName="enterValueWhere">
                            <mat-datepicker-toggle matSuffix [for]="whereDate">
                                <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #whereDate></mat-datepicker>
                        </mat-form-field>
                        </div>
                      </div>
                      
                        <div class="col-lg-1">
                        <label (click)="addWhere()" style="    margin-top: 9px;
                        background: green;
                        margin-bottom: auto;
                        padding: 1px 7px 0px 7px;
                        border-radius: 15px;"><em class="filtersadd fas fa-plus" style="color: antiquewhite;"></em></label>
                      </div>
                      </div>
                    </div>
                  </form>
              </div>
          <div class="container" style="border-bottom: 0.01px ridge coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                        <div class="row topRowMargins">
                         
            <label style="font-weight: 500;
            font-size: larger;
            color: black;">Sorting<em class="fas fa-sort" style="    font-size: 23px;
          padding: 0px 0px 0px 6px;"></em></label>
            </div>
                </div>
                </div>
             
              <div class="container">
                <div class="row" *ngIf="showOrderBy" style="margin-top: -30px;
                margin-bottom: 30px;">
                <div class="table-responsive">
                  <table class="table" style="margin-top: -57px;"><caption></caption>
                    <thead>
                      <tr>
                        <th class="th-lg">Key</th>
                        <th class="th-lg">Allign</th>
                        <th class="th-lg">Remove</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let orderByData of orderBy;let o= index;">
                        <td class="conditionsalign">{{orderByData.orderKey}}</td>
                        <td class="conditionsalign" style="padding-left: 115px;">{{orderByData.orderAllign}}</td>
                        <td class="conditionsalign" style="text-align: end;
                        padding-right: 36px;"><button  class ="CloseButtonStyle"><span> <em (click)="deleteOrder(k)" class="fas fa-minus" style="color: white;"></em></span></button></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
           
                  <form novalidate [formGroup]="formValidWhere">
                    <div>
                      <div class="row topRowMargins" style="margin-top: -25px;">
                        <div class="col-lg-4">
                          <mat-form-field appearance="outline">
                            <mat-label i18n="@@RCFields">Fields</mat-label>
                            <mat-select [(ngModel)]="orderByData.fieldsOrderBy" formControlName="fieldsOrderBy">
                              <mat-option>None</mat-option>
                              <mat-option *ngFor="let field of selectedFieldsDataToPush" [(value)]="field.attributeNameAndFields">
                                {{field.attributeNameAndFields}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-lg-4">
                          <mat-form-field appearance="outline">
                            <mat-label i18n="@@RCConditionalOperators">Sorting</mat-label>
                            <mat-select [(ngModel)]="orderByData.arrangeOrderBy" formControlName="arrangeOrderBy">
                              <mat-option>None</mat-option>
                              <mat-option *ngFor="let arrange of arrangeDataOrderBy" [(value)]="arrange.value">
                                {{arrange.name}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      
                        <div class="col-lg-1">
                      <label (click)="addOrderBy()" style="    margin-top: 9px;
                      background: green;
                      margin-bottom: auto;
                      padding: 1px 7px 0px 7px;
                      border-radius: 15px;"><em class="sortingsadd fas fa-plus" style="    color: antiquewhite;"></em></label>
                    </div>
                    </div>
                  </div>
                  </form>
              </div>
          <div class="container" style="border-bottom: 0.01px ridge coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                        <div class="row topRowMargins">
                         
            <label style="font-weight: 500;
            font-size: larger;
            color: black;">Aggregate<em class="fas fa-calculator" style="    font-size: 23px;
          padding: 0px 0px 0px 6px;"></em></label>
            </div>
                </div>
                </div>
              
              <div class="container">
                <div class="row" *ngIf="showAggregate" style="margin-top: -30px;
                margin-bottom: 30px;">
                <div class="table-responsive">
                  <table class="table" style="margin-top: -57px;"><caption></caption>
                    <thead>
                      <tr>
                        <th class="th-lg">Key</th>
                        <th class="th-lg">Allign</th>
                        <th class="th-lg">Remove</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let aggregateByData of aggregateBy;let a= index;">
                        <td class="conditionsalign">{{aggregateByData.aggregateKey}}</td>
                        <td class="conditionsalign" style="padding-left: 115px;">{{aggregateByData.aggregate}}</td>
                        <td class="conditionsalign" style="text-align: end;
                        padding-right: 36px;"><button  class ="CloseButtonStyle"><span> <em (click)="deleteAggregate(k)" class="fas fa-minus" style="color: white;"></em></span></button></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
                  <form novalidate [formGroup]="formValidWhere">
                    <div>
                      <div class="row topRowMargins" style="margin-top: -25px;">
                        <div class="col-lg-4">
                          <mat-form-field appearance="outline">
                            <mat-label i18n="@@RCFields">Fields</mat-label>
                            <mat-select [(ngModel)]="aggregateByData.fieldsAggregateBy" formControlName="fieldsAggredateBy">
                              <mat-option>None</mat-option>
                              <mat-option *ngFor="let field of selectedFieldsDataToPush" [(value)]="field.attributeNameAndFields">
                                {{field.attributeNameAndFields}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-lg-4">
                          <mat-form-field appearance="outline">
                            <mat-label i18n="@@RCFields">Aggregate</mat-label>
                            <mat-select [(ngModel)]="aggregateByData.arrangeaggregateBy" formControlName="arrangeaggregateBy">
                              <mat-option>None</mat-option>
                              <mat-option *ngFor="let aggregate of arrangeDataBy" [(value)]="aggregate.value">
                                {{aggregate.name}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      
                        <div class="col-lg-1">
                        <label (click)="addAggregate()" style="margin-top: 9px;
                        background: green;
                        margin-bottom: auto;
                        padding: 1px 7px 0px 7px;
                        border-radius: 15px;"><em class="aggregateadd fas fa-plus" style="    color: antiquewhite;"></em></label>
                    </div>
                    </div>
                  </div>
                  </form>
              </div>


          <!-- Formula Field Section -->
          <div class="col-lg">
            
              <label style="font-weight: 500; margin-left: 60px;
            font-size: larger;
            color: black;">Formula Fields<em class="fas fa-file" style="    font-size: 23px;
          padding: 0px 0px 0px 6px;"></em></label>
              <div class="container" style="margin-top: 15px; width: 100%; margin-bottom: 40px;">

                <form novalidate [formGroup]="formulaFields">
                  <div class="row">
                    <div class="col-lg-2">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCLabel">Label</mat-label>
                        <input matInput type="text" maxlength="50" formControlName="label" [(ngModel)]="formulaFieldsByData.labelformulafieldsBy">
                        <mat-error *ngFor="let validation of validation_messages.label">
                      <span
                          *ngIf="formulaFields.get('label').hasError(validation.type) && (formulaFields.get('label').dirty || formulaFields.get('label').touched)">
                          {{ validation.message }}
                      </span>
                  </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-2">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCReturntype">Return Type</mat-label>
                        <mat-select [(ngModel)]="formulaFieldsByData.returntypeformulafieldsBy" formControlName="returntype">
                          <mat-option value="textbox">Text</mat-option>
                          <mat-option value="textbox">Number</mat-option>
                          <mat-option value="Date">Date</mat-option>
                          <mat-option value="Yes/No">Yes/No</mat-option>
                          <mat-option value="DateTime">DateTime</mat-option>
                          <mat-option value="Icon">Icon</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                 
                    <div class="col-lg-2">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCObject">Fields</mat-label>
                        <mat-select [(ngModel)]="formulaFieldsByData.objectformulafieldsBy" formControlName="object">
                          <mat-option>None</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-2">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCFunctions">Functions</mat-label>
                        <mat-select [(ngModel)]="formulaFieldsByData.functionsformulafieldsBy" formControlName="functions">
                          <mat-option>None</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-2">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCOprations">Operations</mat-label>
                        <mat-select [(ngModel)]="formulaFieldsByData.oprationsformulafieldsBy" formControlName="oprations">
                          <mat-option>None</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-1">
                      <label style="margin-top: 9px;
                      background: green;
                      margin-bottom: auto;
                      padding: 1px 7px 0px 7px;
                      border-radius: 15px;">
                        <em class="fas fa-plus" style="color: antiquewhite;"></em>
                      </label>
                    
                    </div>
                  
                  </div>
                </form>

              </div>

          </div>
        
          <div>
            <mat-toolbar class="agGridtoperDiv card" style="
                    background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;">

                        <label i18n="@@spmsUserReg" class="textColour">Report Lists</label>
                        <span class="example-spacer"></span>
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Download" (click) = "onBtExport()">Download
                          <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                  </button>
                    <div class="insertPageNoDiv">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
                            <input matInput type="text" (input)="onSearchChange($event.target.value)">
                        </mat-form-field>
                    </div>

                    <div class="selectRecordsDiv" style="width:9.5%">
                        <mat-form-field appearance="outline" style="width:100%">
                            <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
                            <mat-select [(ngModel)]="pagesize" (ngModelChange)="onPageSizeChanged(value)">
                                <mat-option value="10" selected>10</mat-option>
                                <mat-option value="200">200</mat-option>
                                <mat-option value="300">300</mat-option>
                                <mat-option value="400">400</mat-option>
                            </mat-select>

                        </mat-form-field>
                    </div>
                    <div class="card pagination paginationFirstButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                    </div>
                    <div class="card pagination paginationButtons btn-rounded">
                        <ul>
                            <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                    (click)="onBtPrevious()"></em></li>
                            <li>{{currentpage}}/{{totalpages}}</li>
                            <li class="paginationliicon" style="padding:0;"><em
                                    class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                        </ul>
                    </div>
                    <div class="card pagination paginationLastButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                    </div>
                  </mat-toolbar>
                </div>
          <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
          [columnDefs]="columnDefs"  [animateRows]="true"
          [pagination]="true" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
          [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
          [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
          [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
          (paginationChanged)="onPaginationChanged()" [components]="components"
          (gridReady)="onGridReady($event)" [hidden]="!true">
      </ag-grid-angular>

          <div class="col-lg">
            <div class="container" style="text-align: center;">
              <div class="row topRowMargins">
                <div class="col-lg-4"></div>
                <div class="col-lg-2">
                  <button i18n="@@TMRunButton" type="button" (click)="createreport()" [style.background-color]="backgroundColorButton"
                  class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;">Create</button>
                </div>
                <div class="col-lg-2">
                  <button i18n="@@TMRunButton" type="button" (click)="cancel()" [style.border-color]="backgroundColorButton"
                  class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;">Cancel</button>
                </div>
                <div class="col-lg-4">
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>

